import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { BRAND, NAV_LINKS } from "../data";

export default function Navbar({ onQuote }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-40 transition-colors duration-300 ${
        scrolled ? "bg-white/85 backdrop-blur-xl border-b border-verra-blue/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5">
          <span className="bg-white rounded-lg px-3 py-2 shadow-sm">
            <img src={BRAND.logo} alt="Verraleaf" className="h-7 md:h-8 w-auto" />
          </span>
          <span className={`hidden sm:inline text-xs italic ${scrolled ? "text-verra-blue/60" : "text-white/70"}`}>by</span>
          <span className="hidden sm:block bg-white rounded-lg px-2 py-1.5 shadow-sm">
            <img src={BRAND.parentLogo} alt="Dhananjay Eximporter" className="h-8 md:h-9 w-auto" />
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`text-sm font-medium transition-colors duration-200 hover:text-verra-green ${scrolled ? "text-verra-blue/70" : "text-white/85"}`}
            >
              {l.label}
            </a>
          ))}
          <button
            data-testid="nav-quote-btn"
            onClick={onQuote}
            className={`rounded-full text-sm font-semibold px-6 py-2.5 transition-colors duration-300 ${scrolled ? "bg-verra-blue text-white hover:bg-verra-green" : "bg-white text-verra-blue hover:bg-verra-green hover:text-white"}`}
          >
            Request a Quote
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className={`md:hidden ${scrolled ? "text-verra-blue" : "text-white"}`}
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-white border-t border-verra-blue/10 px-6 py-6 flex flex-col gap-5">
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-verra-blue/80 font-medium">
              {l.label}
            </a>
          ))}
          <button
            data-testid="mobile-quote-btn"
            onClick={() => { setOpen(false); onQuote(); }}
            className="rounded-full bg-verra-blue text-white font-semibold px-6 py-3"
          >
            Request a Quote
          </button>
        </div>
      )}
    </header>
  );
}
